var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 19.9297C15.2578 19.9297 15.5234 19.8594 15.7578 19.7188C15.9974 19.5781 16.1875 19.3906 16.3281 19.1562C16.474 18.9219 16.5469 18.6589 16.5469 18.3672C16.5469 17.9349 16.3932 17.5677 16.0859 17.2656C15.7786 16.9583 15.4036 16.8047 14.9609 16.8047C14.6745 16.8047 14.4115 16.875 14.1719 17.0156C13.9375 17.1562 13.75 17.3464 13.6094 17.5859C13.4688 17.8203 13.3984 18.0807 13.3984 18.3672C13.3984 18.6589 13.4688 18.9219 13.6094 19.1562C13.75 19.3906 13.9375 19.5781 14.1719 19.7188C14.4115 19.8594 14.6745 19.9297 14.9609 19.9297ZM20.7656 19.9297C21.0573 19.9297 21.3203 19.8594 21.5547 19.7188C21.7891 19.5781 21.9766 19.3906 22.1172 19.1562C22.2578 18.9219 22.3281 18.6589 22.3281 18.3672C22.3281 17.9349 22.1745 17.5677 21.8672 17.2656C21.5651 16.9583 21.1979 16.8047 20.7656 16.8047C20.4792 16.8047 20.2161 16.875 19.9766 17.0156C19.7422 17.1562 19.5547 17.3464 19.4141 17.5859C19.2786 17.8203 19.2109 18.0807 19.2109 18.3672C19.2109 18.6589 19.2786 18.9219 19.4141 19.1562C19.5547 19.3906 19.7422 19.5781 19.9766 19.7188C20.2161 19.8594 20.4792 19.9297 20.7656 19.9297ZM26.5703 19.9297C26.8568 19.9297 27.1172 19.8594 27.3516 19.7188C27.5911 19.5781 27.7812 19.3906 27.9219 19.1562C28.0625 18.9219 28.1328 18.6589 28.1328 18.3672C28.1328 17.9349 27.9792 17.5677 27.6719 17.2656C27.3698 16.9583 27.0026 16.8047 26.5703 16.8047C26.2786 16.8047 26.013 16.875 25.7734 17.0156C25.5339 17.1562 25.3438 17.3464 25.2031 17.5859C25.0625 17.8203 24.9922 18.0807 24.9922 18.3672C24.9922 18.6589 25.0625 18.9219 25.2031 19.1562C25.3438 19.3906 25.5339 19.5781 25.7734 19.7188C26.013 19.8594 26.2786 19.9297 26.5703 19.9297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_506",
    x: 9.39844,
    y: 14.8047,
    width: 22.7344,
    height: 11.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0431373 0 0 0 0 0.0470588 0 0 0 0 0.0823529 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_506",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.9d5418f31cb03d3f5f09f51e47c526c4.svg";
export { ForwardRef as ReactComponent };